import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const AlignVerticalSpaceAround: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['rect', { x: '7', y: '9', width: '10', height: '6', rx: '2' }],
    ['path', { d: 'M22 20H2' }],
    ['path', { d: 'M22 4H2' }],
  ],
];

export default AlignVerticalSpaceAround;
